// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce16b764","455":"81e5ff9a","977":"91f47962"}[chunkId] + ".chunk.js";
};